var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", [
    _c("div", { attrs: { slot: "header" }, slot: "header" }, [
      _c("span", [_vm._v("Order Information")]),
      _vm.value.deleted
        ? _c(
            "span",
            {
              staticStyle: {
                float: "right",
                "margin-right": "20px",
                color: "red",
                "font-weight": "Bold",
              },
            },
            [_vm._v(" DELETED ORDER ")]
          )
        : _vm._e(),
    ]),
    _c(
      "div",
      { staticClass: "ca-form" },
      [
        _c(
          "div",
          { staticClass: "ca-single-line" },
          [
            _c(
              "el-form-item",
              {
                staticClass: "w-50",
                attrs: {
                  label: "Client Name",
                  prop: "clientId",
                  required: _vm.isEdit !== true,
                  inlineMessage: true,
                },
              },
              [
                _vm.isEdit
                  ? _c("div", [_c("b", [_vm._v(_vm._s(_vm.value.clientName))])])
                  : _c("ClientIdOption", {
                      on: { input: _vm.handleClientChange },
                      model: {
                        value: _vm.value.clientId,
                        callback: function ($$v) {
                          _vm.$set(_vm.value, "clientId", $$v)
                        },
                        expression: "value.clientId",
                      },
                    }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.value.orderId,
                    expression: "value.orderId",
                  },
                ],
                staticClass: "w-50",
                attrs: {
                  label: "Order Status",
                  prop: "orderId",
                  inlineMessage: true,
                },
              },
              [_c("b", [_vm._v(_vm._s(_vm.value.orderStatus))])]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "ca-single-line" },
          [
            _c(
              "el-form-item",
              {
                staticClass: "w-50",
                attrs: {
                  label: "Product",
                  prop: "productId",
                  required: _vm.isEdit !== true,
                  inlineMessage: true,
                },
              },
              [
                _vm.isEdit && _vm.value.product
                  ? _c("div", [
                      _c("b", [_vm._v(_vm._s(_vm.value.product.name))]),
                      _c("small", { staticStyle: { "margin-left": "10px" } }, [
                        _vm._v("(" + _vm._s(_vm.getOrderTypeName()) + ")"),
                      ]),
                    ])
                  : _c("div", [
                      _vm.value.clientId
                        ? _c(
                            "div",
                            [
                              _c("ProductOption", {
                                key: _vm.value.clientId,
                                attrs: { clientId: _vm.value.clientId },
                                on: { input: _vm.handleProductChange },
                                model: {
                                  value: _vm.value.productId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.value, "productId", $$v)
                                  },
                                  expression: "value.productId",
                                },
                              }),
                            ],
                            1
                          )
                        : _c("div", [
                            _c("span", [_vm._v("Please Select a Client.")]),
                          ]),
                    ]),
              ]
            ),
            _c(
              "el-form-item",
              {
                staticClass: "w-50",
                attrs: {
                  label: "Client Order Id",
                  prop: "clientOrderId",
                  required: "",
                  inlineMessage: true,
                },
              },
              [
                _c("el-input", {
                  attrs: { maxlength: "50", placeholder: "Client Order Id" },
                  model: {
                    value: _vm.value.clientOrderId,
                    callback: function ($$v) {
                      _vm.$set(_vm.value, "clientOrderId", $$v)
                    },
                    expression: "value.clientOrderId",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "ca-single-line" },
          [
            _c(
              "el-form-item",
              {
                staticClass: "w-50",
                attrs: {
                  label: "Lender Name",
                  prop: "lenderName",
                  required: "",
                  inlineMessage: true,
                },
              },
              [
                _c("el-input", {
                  attrs: { maxlength: "50", placeholder: "Lender Name" },
                  model: {
                    value: _vm.value.lenderName,
                    callback: function ($$v) {
                      _vm.$set(_vm.value, "lenderName", $$v)
                    },
                    expression: "value.lenderName",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                staticClass: "w-50",
                attrs: { label: "Loan #", prop: "loanNumber" },
              },
              [
                _c("el-input", {
                  attrs: { maxlength: "50", placeholder: "Loan Number" },
                  model: {
                    value: _vm.value.loanNumber,
                    callback: function ($$v) {
                      _vm.$set(_vm.value, "loanNumber", $$v)
                    },
                    expression: "value.loanNumber",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "ca-single-line" },
          [
            _c(
              "el-form-item",
              {
                staticClass: "w-50",
                attrs: {
                  label: "Borrower",
                  prop: "borrowerName",
                  required: "",
                  inlineMessage: true,
                },
              },
              [
                _c("el-input", {
                  attrs: { maxlength: "50", placeholder: "Borrower Name" },
                  model: {
                    value: _vm.value.borrowerName,
                    callback: function ($$v) {
                      _vm.$set(_vm.value, "borrowerName", $$v)
                    },
                    expression: "value.borrowerName",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { staticClass: "w-50", attrs: { label: "Borrower 2" } },
              [
                _c("el-input", {
                  attrs: {
                    maxlength: "50",
                    placeholder: "Second Borrower Name",
                  },
                  model: {
                    value: _vm.value.borrowerName2,
                    callback: function ($$v) {
                      _vm.$set(_vm.value, "borrowerName2", $$v)
                    },
                    expression: "value.borrowerName2",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "ca-single-line" },
          [
            _c(
              "el-form-item",
              { staticClass: "w-50", attrs: { label: "Appraisal Id" } },
              [
                _c("el-input", {
                  attrs: { maxlength: "50", placeholder: "Appraisal #" },
                  model: {
                    value: _vm.value.appraisalId,
                    callback: function ($$v) {
                      _vm.$set(_vm.value, "appraisalId", $$v)
                    },
                    expression: "value.appraisalId",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "ca-single-line" },
          [
            _c(
              "el-form-item",
              { staticClass: "w-50", attrs: { label: "Seller/Case File Id" } },
              [
                _c("el-input", {
                  attrs: { maxlength: "50", placeholder: "Seller Id" },
                  model: {
                    value: _vm.value.sellerId,
                    callback: function ($$v) {
                      _vm.$set(_vm.value, "sellerId", $$v)
                    },
                    expression: "value.sellerId",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { staticClass: "w-50", attrs: { label: "LPA Key" } },
              [
                _c("el-input", {
                  attrs: { maxlength: "50", placeholder: "LPA Key" },
                  model: {
                    value: _vm.value.lpaKey,
                    callback: function ($$v) {
                      _vm.$set(_vm.value, "lpaKey", $$v)
                    },
                    expression: "value.lpaKey",
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm.isEdit && _vm.isAdmin
          ? _c(
              "div",
              { staticClass: "ca-single-line" },
              [
                _c(
                  "el-form-item",
                  {
                    staticClass: "w-50",
                    attrs: { label: "Vendor Fee", required: "" },
                  },
                  [
                    _vm._v(" $ "),
                    _c("el-input", {
                      attrs: {
                        min: "0",
                        type: "number",
                        placeholder: "Vendor Fee",
                      },
                      model: {
                        value: _vm.value.vendorFee,
                        callback: function ($$v) {
                          _vm.$set(_vm.value, "vendorFee", $$v)
                        },
                        expression: "value.vendorFee",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "Client Fee" } },
                  [
                    _vm._v(" $ "),
                    _vm.isAdmin
                      ? _c("el-input", {
                          attrs: { min: "0" },
                          model: {
                            value: _vm.value.orderFee,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "orderFee", $$v)
                            },
                            expression: "value.orderFee",
                          },
                        })
                      : _c("span", [
                          _vm._v(" " + _vm._s(_vm.value.orderFee) + " "),
                        ]),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _vm.isEdit
          ? _c(
              "el-button",
              {
                staticStyle: { "margin-top": "10px" },
                attrs: { type: "success" },
                on: {
                  click: function ($event) {
                    _vm.dialogAddComment = true
                  },
                },
              },
              [_vm._v(" Add comment ")]
            )
          : _vm._e(),
        _c(
          "el-dialog",
          {
            staticClass: "dialog-confirm-vendor-fee",
            attrs: {
              "close-on-click-modal": false,
              title: "Add Commment",
              visible: _vm.dialogAddComment,
              width: "80%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogAddComment = $event
              },
            },
          },
          [
            _c("el-input", {
              attrs: { placeholder: "Add comment...", type: "textarea" },
              model: {
                value: _vm.comment,
                callback: function ($$v) {
                  _vm.comment = $$v
                },
                expression: "comment",
              },
            }),
            _c(
              "div",
              {
                staticClass: "ForwardToIntegrationCheckBox",
                attrs: { show: _vm.isValueLinkOrder },
              },
              [
                _c("el-checkbox", {
                  attrs: {
                    label: "Send a copy of this Comment to Integration?",
                  },
                  model: {
                    value: _vm.forwardToIntegrationCheck,
                    callback: function ($$v) {
                      _vm.forwardToIntegrationCheck = $$v
                    },
                    expression: "forwardToIntegrationCheck",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-button",
              {
                staticStyle: { "margin-top": "15pt" },
                attrs: { type: "success", disabled: _vm.comment.length <= 0 },
                on: { click: _vm.addComment },
              },
              [_vm._v(" Add comment ")]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }